import { render, staticRenderFns } from "./PelletsTrustBadges.vue?vue&type=template&id=86c3bcf4&scoped=true"
import script from "./PelletsTrustBadges.vue?vue&type=script&lang=ts"
export * from "./PelletsTrustBadges.vue?vue&type=script&lang=ts"
import style0 from "./PelletsTrustBadges.vue?vue&type=style&index=0&id=86c3bcf4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c3bcf4",
  null
  
)

export default component.exports